/**
 * Author: SCS (Santosh Chandra Shekhar)
 * ***scs***
 */

import React, { useContext, useRef } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper";
import "swiper/css";
import Sidebar from "../../img/sidebar.png";
import Ecommerce from "../../img/ecommerce.png";
import HOC from "../../img/hoc.png";
import MusicApp from "../../img/musicapp.png";
import { themeContext } from "../../Context";

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const swiperRef = useRef(null);

  const handleReachEnd = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      const swiper = swiperRef.current;
      // Reverse the direction
      swiper.params.autoplay.reverseDirection = !swiper.params.autoplay.reverseDirection;
      // Change slide direction
      swiper.changeLanguageDirection(swiper.params.autoplay.reverseDirection ? 'rtl' : 'ltr');
    }
  };

  const handleReachBeginning = () => {
    if (swiperRef.current && swiperRef.current.autoplay && swiperRef.current.params.autoplay.reverseDirection) {
      const swiper = swiperRef.current;
      // Reverse back to normal direction
      swiper.params.autoplay.reverseDirection = false;
      swiper.changeLanguageDirection('ltr');
    }
  };

  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{color: darkMode?'white': ''}}>Recent Projects</span>
      {/* <span>Portfolio</span> */}

      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        modules={[Autoplay]}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
          reverseDirection: false,
        }}
        loop={true}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onReachEnd={handleReachEnd}
        onReachBeginning={handleReachBeginning}
        className="portfolio-slider"
        
      >
        <SwiperSlide>
          <img src={Sidebar} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Ecommerce} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={MusicApp} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={HOC} alt="" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;
